import React from "react";
import isPropsEqual from "react-fast-compare";
import TextField, { TextFieldProps } from "@mui/material/TextField";

function TextInput(props: TextFieldProps) {
  return <TextField {...props} />;
}

export default React.memo(TextInput, isPropsEqual);
